
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Job } from '@/types/job';
import { Button } from "@/components/ui/button";
import { ExternalLink, Heart, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { LikedJobsProps } from '@/types/job';

export const LikedJobs: React.FC<LikedJobsProps> = ({ likedJobs, onViewDetails }) => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 10 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <Card className="bg-white/90 backdrop-blur-sm shadow-md border-0 rounded-xl overflow-hidden">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <Heart className="h-5 w-5 text-rose-500" />
          <h2 className="text-lg font-semibold">Your Matches</h2>
        </div>

        <motion.div 
          className="space-y-3"
          variants={container}
          initial="hidden"
          animate="show"
        >
          {likedJobs.length > 0 ? (
            likedJobs.map((job, index) => (
              <motion.div 
                key={job.id} 
                className="p-3 rounded-lg hover:bg-gray-50 transition-colors border-b last:border-0 flex items-center justify-between group cursor-pointer"
                variants={item}
                onClick={() => onViewDetails && onViewDetails(job)}
                whileHover={{ x: 5 }}
              >
                <div>
                  <p className="font-medium text-gray-900 group-hover:text-sky-600 transition-colors">{job.title}</p>
                  <p className="text-sm text-gray-500">{job.company}</p>
                </div>
                <div className="flex items-center gap-2">
                  <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                    {job.matchScore || 0}%
                  </Badge>
                  <ChevronRight className="h-4 w-4 text-gray-400 group-hover:text-sky-500 transition-colors opacity-0 group-hover:opacity-100" />
                </div>
              </motion.div>
            ))
          ) : (
            <motion.div 
              className="text-center py-8 text-gray-500"
              variants={item}
            >
              <div className="mb-3 opacity-50">
                <Heart className="h-10 w-10 mx-auto" />
              </div>
              <p className="text-sm">Like jobs to see them here</p>
            </motion.div>
          )}
        </motion.div>
      </CardContent>
    </Card>
  );
};
